"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidAddress = exports.validateEmail = exports.date = exports.money = exports.radioButton = exports.email = exports.mandatory = void 0;
var moment = require("moment");
var validate = require("validate.js");
validate.extend(validate.validators.datetime, {
    parse: function (value, options) {
        return +moment.utc(value);
    },
    format: function (value, options) {
        var format = options.dateOnly ? "DD-MM-YYYY" : "YYYY-MM-DD hh:mm:ss";
        return moment.utc(value).format(format);
    }
});
exports.mandatory = {
    presence: { allowEmpty: false }
};
exports.email = {
    presence: { allowEmpty: false },
    email: true
};
exports.radioButton = {
    presence: { allowEmpty: false },
    inclusion: ["yes", "no"]
};
exports.money = {
    presence: { allowEmpty: false },
    numericality: {
        greaterThan: 0
    }
};
exports.date = {
    presence: { allowEmpty: false },
    datetime: {
        dateOnly: true,
        latest: moment.utc().year(3000),
        message: "Invalid date"
    }
};
var validateEmail = function (mail) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(mail);
};
exports.validateEmail = validateEmail;
var isValidAddress = function (address) {
    var regex = /^[a-zA-Z0-9\s\-\,\#]+$/;
    return regex.test(address);
};
exports.isValidAddress = isValidAddress;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFsaWRhdGlvbnMuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9saWIvZnVuY3Rpb25zL3ZhbGlkYXRpb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLCtCQUFpQztBQUNqQyxzQ0FBd0M7QUFFeEMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsVUFBVSxDQUFDLFFBQVEsRUFBRTtJQUcxQyxLQUFLLEVBQUUsVUFBVSxLQUFLLEVBQUUsT0FBTztRQUMzQixPQUFPLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQTtJQUM3QixDQUFDO0lBRUQsTUFBTSxFQUFFLFVBQVUsS0FBSyxFQUFFLE9BQU87UUFDNUIsSUFBSSxNQUFNLEdBQUcsT0FBTyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsWUFBWSxDQUFDLENBQUMsQ0FBQyxxQkFBcUIsQ0FBQTtRQUNwRSxPQUFPLE1BQU0sQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLENBQUMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFBO0lBQzNDLENBQUM7Q0FDSixDQUFDLENBQUE7QUFFVyxRQUFBLFNBQVMsR0FBRztJQUNyQixRQUFRLEVBQUUsRUFBQyxVQUFVLEVBQUUsS0FBSyxFQUFDO0NBQ2hDLENBQUE7QUFFWSxRQUFBLEtBQUssR0FBRztJQUNqQixRQUFRLEVBQUUsRUFBQyxVQUFVLEVBQUUsS0FBSyxFQUFDO0lBQzdCLEtBQUssRUFBRSxJQUFJO0NBQ2QsQ0FBQTtBQUVZLFFBQUEsV0FBVyxHQUFHO0lBQ3ZCLFFBQVEsRUFBRSxFQUFDLFVBQVUsRUFBRSxLQUFLLEVBQUM7SUFDN0IsU0FBUyxFQUFFLENBQUMsS0FBSyxFQUFFLElBQUksQ0FBQztDQUMzQixDQUFBO0FBRVksUUFBQSxLQUFLLEdBQUc7SUFDakIsUUFBUSxFQUFFLEVBQUMsVUFBVSxFQUFFLEtBQUssRUFBQztJQUM3QixZQUFZLEVBQUU7UUFDVixXQUFXLEVBQUUsQ0FBQztLQUNqQjtDQUNKLENBQUE7QUFFWSxRQUFBLElBQUksR0FBRztJQUNoQixRQUFRLEVBQUUsRUFBQyxVQUFVLEVBQUUsS0FBSyxFQUFDO0lBQzdCLFFBQVEsRUFBRTtRQUNOLFFBQVEsRUFBRSxJQUFJO1FBQ2QsTUFBTSxFQUFFLE1BQU0sQ0FBQyxHQUFHLEVBQUUsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDO1FBQy9CLE9BQU8sRUFBRSxjQUFjO0tBQzFCO0NBQ0osQ0FBQTtBQUVNLElBQU0sYUFBYSxHQUFHLFVBQUMsSUFBSTtJQUM5QixJQUFNLEVBQUUsR0FBRywySkFBMkosQ0FBQTtJQUN0SyxPQUFPLEVBQUUsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUE7QUFDeEIsQ0FBQyxDQUFBO0FBSFksUUFBQSxhQUFhLGlCQUd6QjtBQUVNLElBQU0sY0FBYyxHQUFHLFVBQUMsT0FBTztJQUNsQyxJQUFNLEtBQUssR0FBRyx3QkFBd0IsQ0FBQTtJQUN0QyxPQUFPLEtBQUssQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUE7QUFDOUIsQ0FBQyxDQUFBO0FBSFksUUFBQSxjQUFjLGtCQUcxQiJ9